var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.incomes.length ? _c('div', {
    staticClass: "income-group"
  }, [_c('div', {
    staticClass: "income-group__title"
  }, [_vm._v(" " + _vm._s(_vm.role === "applicant" ? "Žiadateľ" : "Spolužiadateľ") + " ")]), _vm._l(_vm.incomes, function (income) {
    return _c('article', {
      key: income.id,
      staticClass: "income-card",
      "class": {
        'income-card--rejected': !income.success
      }
    }, [_c('div', {
      staticClass: "income-card__header"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(income.type))]), _c('strong', [_vm._v(_vm._s(income.employer || income.type))])]), _c('div', {
      staticClass: "income-card__accepted"
    }, [_c('span', [_vm._v(_vm._s(income.success ? "Akceptovaný príjem" : "Neakceptovaný príjem"))]), _c('strong', [_vm._v(_vm._s(income.success ? _vm.money(income.acceptedMonthly) : "0 EUR") + " / mes.")])])]), income.facts.length ? _c('ul', {
      staticClass: "income-card__facts"
    }, _vm._l(income.facts, function (fact, index) {
      return _c('li', {
        key: index
      }, [_vm._v(_vm._s(fact))]);
    }), 0) : _vm._e(), income.annualDebtCapacity !== null ? _c('div', {
      staticClass: "income-card__capacity"
    }, [_vm._v(" Doplnková kontrola DTI: z tohto príjmu vzniká limit celkového zadlženia "), _c('strong', [_vm._v(_vm._s(_vm.money(income.annualDebtCapacity)))]), _vm._v(". ")]) : _vm._e(), income.details.length ? _c('div', {
      staticClass: "income-card__details"
    }, [_vm._v(" " + _vm._s(income.details.join(" ")) + " ")]) : _vm._e()]);
  })], 2) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }